export const chakraStyles = {
  disabled: {
    backgroundColor: "rgba(236, 236, 236, 0.3)",
    color: "sk-gray",
    cursor: "not-allowed",
    borderColor: "sk-light-gray",
  },
};
